import { List, ListItem, Typography } from '@mui/material';
import numeral from 'numeral';
import { type Observation } from '../../../shared/types';
import { formatTimeFromString } from '../helpers';

type Props = {
    observation: Observation;
};

export const Yesterday = ({ observation }: Props) => {
    return (
        <List>
            <ListItem dense={true} sx={{ pt: 1 }}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>{`Max Temp:`}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {numeral(observation.day.maxTemp).format('0.0')}&#176;{` (${formatTimeFromString(observation.day.timeMaxTemp)})`}
                </Typography>
            </ListItem>
            <ListItem dense={true}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>{`Min Temp:`}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {numeral(observation.day.minTemp).format('0.0')}&#176;{` (${formatTimeFromString(observation.day.timeMinTemp)})`}
                </Typography>
            </ListItem>
            <ListItem dense={true}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>{`24hr PCPN:`}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {numeral(observation.day.totalPcpn).format('0.00')} IN
                </Typography>
            </ListItem>
            <ListItem dense={true}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>{`GDD50:`}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {numeral(observation.day.growingDegreeDaysSimple).format('0.0')}&#176;
                </Typography>
            </ListItem>
            {observation.day.totalETo > -100 && (
                <ListItem dense={true}>
                    <Typography variant="subtitle1" sx={{ mr: 1 }}>{`24hr ETo:`}</Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        {numeral(observation.day.totalETo).format('0.000')} IN
                    </Typography>
                </ListItem>
            )}
            <ListItem dense={true}>
                <Typography variant="subtitle1" sx={{ mr: 1 }}>{`YTD PCPN:`}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {numeral(observation.day.seasonalYearlyPcpn).format('0.00')} IN (July 1 - June 30)
                </Typography>
            </ListItem>
        </List>
    );
};
